<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.materialNumber')">
              <j-input  :placeholder="$t('label.pleaseEnterTheMaterialNo')" v-model="queryParam.mmCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.materialCommonName')">
              <j-input  :placeholder="$t('label.pleaseEnterTheCommonNameOfTheMaterial')" v-model="queryParam.mmName"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.validOrNot')">
                <j-dict-select-tag  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" v-model="queryParam.validFlag" dictCode="sfyx"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button v-show=false @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('集团价格清单')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <a-button :disabled="isSyncUpdateDataDisabled" @click="syncUpdateData" type="primary" icon="sync">{{$t('button.synchronousUpdate')}}</a-button>
      <!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
      <a-dropdown v-show="false">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>
<!--        <template slot="imgSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>-->
<!--          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>-->
<!--        </template>-->
<!--        <template slot="fileSlot" slot-scope="text">-->
<!--          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>-->
<!--          <a-button-->
<!--            v-else-->
<!--            :ghost="true"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--            size="small"-->
<!--            @click="downloadFile(text)">-->
<!--            下载-->
<!--          </a-button>-->
<!--        </template>-->

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-group-price-list-modal ref="modalForm" @ok="modalFormOk"></efs-md-group-price-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdGroupPriceListModal from './modules/EfsMdGroupPriceListModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JInput from '@/components/jeecg/JInput'
  import { getAction, getActionLongWait, deleteAction, putAction, postAction, httpAction } from '@/api/manage'

  export default {
    name: 'EfsMdGroupPriceListList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDictSelectTag,
      JSearchSelectTag,
      EfsMdGroupPriceListModal,
      JInput
    },
    data () {
      return {
        description: '集团价格清单管理页面',
        // 表头
        columns: [
          {
            slotName: 'tableHeader.materialNumber',
            scopedSlots: { title: 'tableHeader.materialNumber'},
            align:"center",
            dataIndex: 'mmCode'
          },
          {
            slotName: 'tableHeader.materialCategory',
            scopedSlots: { title: 'tableHeader.materialCategory'},
            align:"center",
            dataIndex: 'mmCategory_dictText'
          },
          {
             slotName: 'tableHeader.materialCommonName',
            scopedSlots: { title: 'tableHeader.materialCommonName'},
            align:"center",
            dataIndex: 'mmName'
          },
          {
             slotName: 'tableHeader.specification',
            scopedSlots: { title: 'tableHeader.specification'},
            align:"center",
            dataIndex: 'spec'
          },
          {
             slotName: 'tableHeader.model',
            scopedSlots: { title: 'tableHeader.model'},
            align:"center",
            dataIndex: 'model'
          },
          {
             slotName: 'tableHeader.unitOfMeasurement',
            scopedSlots: { title: 'tableHeader.unitOfMeasurement'},
            align:"center",
            dataIndex: 'unit_dictText'
          },
          {
             slotName: 'tableHeader.unitPrice',
            scopedSlots: { title: 'tableHeader.unitPrice'},
            align:"center",
            dataIndex: 'price'
          },
          {
             slotName: 'tableHeader.description',
            scopedSlots: { title: 'tableHeader.description'},
            align:"center",
            dataIndex: 'description'
          },
          // {
          //   title:'是否有效',
          //   align:"center",
          //   dataIndex: 'validFlag_dictText'
          // },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/priceList/groupPriceList/efsMdGroupPriceList/list",
          delete: "/priceList/groupPriceList/efsMdGroupPriceList/delete",
          deleteBatch: "/priceList/groupPriceList/efsMdGroupPriceList/deleteBatch",
          exportXlsUrl: "/priceList/groupPriceList/efsMdGroupPriceList/exportXls",
          importExcelUrl: "priceList/groupPriceList/efsMdGroupPriceList/importExcel",

        },
        dictOptions:{},
        isSyncUpdateDataDisabled: false
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      syncUpdateData(){
        this.isSyncUpdateDataDisabled = true;
        this.loading=true;
        getActionLongWait("/priceList/groupPriceList/efsMdGroupPriceList/syncUpdate",'').then((res)=> {
          if (res.success) {
            this.loadData();
            this.isSyncUpdateDataDisabled = false;
          } else {
            this.$message.warning(res.message);
            this.isSyncUpdateDataDisabled = false;
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>